/****************************************************
 * Module Name:  brokerMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import BrokerMasterComponent from "../common/brokerMasterComponent";
import { Box } from "@mui/material";

export class BrokerMaster extends Component {
  render() {
    return (
      <Box>
        <BrokerMasterComponent editButton={true} />
      </Box>
    );
  }
}

export default BrokerMaster;
